import styled from 'styled-components';
import { Alert } from 'antd';

export const Title = styled.h3`
	margin: 0;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1.25rem;
	font-weight: 600;
	line-height: 2rem;
`;

export const Description = styled.p`
	margin: 0.5rem 0 0;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1rem;
	line-height: 1.5rem;
`;

export const Fields = styled.div`
	margin-top: 2rem;

	.ant-form-item {
		margin-bottom: 0;
	}

	.ant-form-item-label {
		padding-bottom: 0.5rem;
	}

	.ant-form-item-label > label {
		height: auto;
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: 1rem;
		font-weight: 600;
		line-height: 1.5rem;
	}

	.ant-form-item-label > label::after {
		content: '';
		margin: 0;
	}

	.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
		&::before {
			display: none;
		}

		&::after {
			display: inline-block;
			content: '*';
			margin-left: 0.125rem;
			color: ${({ theme }) => theme.palette.risk.high.default};
		}
	}

	.ant-select:not(.ant-select-customize-input) .ant-select-selector,
	.ant-picker,
	.ant-input-number {
		height: 2.5rem;
		border-color: ${({ theme }) => theme.palette.secondary[150]};
		border-radius: 0.25rem;
	}

	.ant-select-selector .ant-select-selection-item,
	.ant-select-selector .ant-select-selection-placeholder,
	.ant-select-selector .ant-select-selection-search-input,
	.ant-input-number-input {
		height: calc(2.5rem - 2px);
		line-height: calc(2.5rem - 2px);
	}

	.ant-picker,
	.ant-input-number {
		width: 100%;
	}
`;

export const NoRiskAlert = styled(Alert)`
	align-items: center;
	gap: 0.5rem;
	padding: 0.5rem;
	background: ${({ theme }) => theme.palette.primary[100]};
	border: none;
	border-radius: 0.25rem;

	.ant-alert-icon {
		width: 1.5rem;
		height: 1.5rem;
		margin-right: 0;
		color: ${({ theme }) => theme.palette.primary[600]};
	}

	.ant-alert-message {
		overflow: hidden;
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: 0.875rem;
		line-height: 1rem;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;
